var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park:success"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36 6L43.8799 11.7481L53.6335 11.7295L56.6299 21.0116L64.5316 26.7296L61.5 36L64.5316 45.2705L56.6299 50.9884L53.6335 60.2705L43.8799 60.252L36 66L28.12 60.252L18.3664 60.2705L15.37 50.9884L7.46826 45.2705L10.5 36L7.46826 26.7296L15.37 21.0116L18.3664 11.7295L28.12 11.7481L36 6Z",
    fill: "#0073FF",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.5 36L33 43.5L48 28.5",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6cbf15c77654effe895e94fc0e7c5824.svg";
export { ForwardRef as ReactComponent };